import script from "./NewsPageStoryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryButton.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryButton.vue?vue&type=style&index=0&id=08e0d494&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e0d494"]])

export default __exports__